import { FactoryProvider } from '@angular/core';
import { TranslationService } from '@lib/i18n/data-access';
import { ActiveLanguageFactory, DATEPICKER_TRANSLATE_ACTIVE_LANGUAGE } from '@platform-workspace/design-system';

export const provideDatepickerActiveLanguage = (): FactoryProvider => ({
  provide: DATEPICKER_TRANSLATE_ACTIVE_LANGUAGE,
  useFactory: (translationService: TranslationService): ActiveLanguageFactory => ({
    getActiveLanguage: () => translationService.getActiveLang(),
  }),
  deps: [TranslationService],
});
